import { motion } from "framer-motion";
import { Flame } from "lucide-react";

export default function FinalCTA() {
  return (
    <section id="contact" className="py-24 lg:py-32 bg-[#17150f]" data-testid="final-cta-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-[#f97316] mb-8">
            <Flame size={24} className="text-white" strokeWidth={2.2} />
          </div>
          <h2 className="font-display font-bold tracking-tight text-3xl sm:text-5xl text-white mb-5" data-testid="final-cta-headline">
            No fire crossing this way.
          </h2>
          <p className="text-base sm:text-lg text-stone-400 leading-relaxed max-w-2xl mx-auto mb-10" data-testid="final-cta-subtext">
            Build wildfire preparedness into your plan today. Contact NOXWAY for product availability, bulk
            pricing, and the right application for your property.
          </p>
          <a
            href="mailto:sales@noxway.shop?subject=NOXWAY%20Product%20Inquiry"
            data-testid="final-cta-button"
            className="inline-flex items-center gap-2.5 font-display font-bold text-sm px-10 py-4 rounded-md bg-[#f97316] text-white hover:bg-[#ea580c] transition-colors"
          >
            CONTACT SALES
          </a>
        </motion.div>
      </div>
    </section>
  );
}
